import { Source } from "@core-ui/constants/TimerOnCart";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import styled from "styled-components";

export const TimerCroutonWrapper = styled.div<{ source?: string }>(({ theme, source }) => ({
    width: "auto",
    left: "0",
    transform: "translate(calc(50vw - 50%))",
    position: "fixed",
    zIndex: 399,
    bottom: `calc(var(--bottom-sheet-height, ${theme.spacing.medium}) + ${theme.spacing.xSmall})`,
    ...(source === Source.CART && {
        bottom: `calc(var(--cart-footer-height) + ${theme.spacing.small})`,
    }),
    ...(source === Source.PAY_HALF_CARD && {
        bottom: `calc(var(--bottom-sheet-height) + ${theme.spacing.xSmall})`,
    }),
}));

export const TimerCroutonContent = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    //TODO: @HIMANSHU finlalise dls color
    background: "#1b1e24",
    boxShadow: `${theme.spacing.empty} ${theme.spacing.xxxSmall} ${theme.spacing.medium} rgba(0, 0, 0, 0.1)`,
    borderRadius: theme.spacing.large,
    height: "40px",
}));

export const TimerCroutonIconContainer = styled.div(({ theme }) => ({
    display: "flex",
    paddingLeft: theme.spacing.small,
    paddingRight: theme.spacing.xSmall,
}));

export const TimerCroutonText = styled(Text)(({ theme }) => ({
    marginRight: theme.spacing.small,
}));
